import { useContext, useState } from 'react';
import { isOptionAllAreas } from '../../components/AreaSelect';
import { AppContext } from '../../contexts/AppContext';
import userAPI from '../../services/UserApi';

const useUsersAdministrationPresenter = () => {
  const { showError } = useContext(AppContext);

  const [firstLoad, setFirstLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [name, setName] = useState('');
  const [id, setId] = useState('');
  const [status, setStatus] = useState(null);
  const [area, setArea] = useState('');
  const [criticos, setCriticos] = useState (null);

  const cleanFilters = () => {
    setName('');
    setId('');
    setStatus(null);
    setArea('');
    setCriticos(null);
  };

  const search = () => {
    const request = {
      Id: id || undefined,
      Name: name || undefined,
      IdArea: !isOptionAllAreas(area) ? area : undefined,
      State: status ? status === 'true' : undefined,
      Critico: criticos ? criticos === 'true' : undefined,
    };

    setFirstLoad(false);
    setLoading(true);

    userAPI
      .getUsers(request)
      .then(res => {
        setRows(res);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        showError('Error al obtener los usuarios');
      });
  };

  const validateFilters = () => {
    // let errors = [];
    // const errorMessages = [];
    // let i = 0;

    // if ((errors[i++] = !isSupplier && !selectedSupplier)) {
    //   errorMessages.push('Debe seleccionar un proveedor para iniciar la búsqueda');
    // }

    // if ((errors[i++] = dateFrom && !dateTo)) {
    //   errorMessages.push('Debe completar el rango de fechas o quitar la Fecha desde');
    // }

    // if ((errors[i++] = !dateFrom && dateTo)) {
    //   errorMessages.push('Debe completar el rango de fechas o quitar la Fecha hasta');
    // }

    // const hasErrors = errors.some(e => e);

    // hasErrors && showWarning(errorMessages);

    // return !hasErrors;

    return true;
  };

  const validateAndSearch = () => validateFilters() && search();

  return {
    criticos,
    setCriticos,
    name,
    setName,
    id,
    setId,
    status,
    setStatus,
    area,
    setArea,
    validateAndSearch,
    cleanFilters,
    rows,
    loading,
    firstLoad,
    search,
  };
};

export default useUsersAdministrationPresenter;
